import { Collection } from "@type-r/models";
import { asDate, asTime, CollapsableSection, FormLabel, FormValue, InlineTable, TableCell, TableRow } from "lqx-react";
import * as React from "react";
import { Fragment } from "react";
import { CollapsibleTableRow } from "../../src/app/pages/invoices/details/additionalInfo";
import { Activity, IncomingRemitanceAdviceActivity, IncomingTransactionActivity, RemittanceLinkedToInvoiceActivity, RemittanceLinkedToTransactionReconciledActivity, TransactionMovedToARActivity, TransactionMovedToNonARActivity, TransactionMovedUACActivity, TransactionReconciledActivity, TransactionUnmatchedActivity } from "api/activity";
import MessageIcon from '@material-ui/icons/Message';
import { IncomingRemitanceAdviceDetails } from "./details/incomingRemitanceAdviceDetails";
import { RemittanceLinkedToInvoiceDetails } from "./details/remittanceLinkedToInvoiceDetails";
import { RemittanceLinkedToTransactionReconciledDetails } from "./details/remittanceLinkedToTransactionReconciledDetails";
import { IncomingTransactionDetails } from "./details/incomingTransactionDetails";
import { TransactionMovedToARDetails } from "./details/transactionMovedToARDetails";
import { TransactionReconciledDetails } from "./details/transactionReconciledDetails";
import { TransactionUnmatchedDetails } from "./details/transactionUnmatchedDetails";
import { TransactionMovedUACDetails } from "./details/transactionMovedUACDetails";
import { TransactionMovedToNonARDetails } from "./details/transactionMovedToNonARDetails";
import { Document } from "api/uploads";
import { Column, Columns, FormInput, FormLink } from "lqx-react/src/forms";

export const AllActivitySection = ({ activities, uploads = null, currency = null } : {
    activities : Collection<Activity>,
    uploads? : Collection<Document>,
    currency? : string
}) => {

    const grouped = activities.groupBy( x => asDate( x.createdOn ) );

    return (
        <CollapsableSection title="All activity" id="all-activity" >
            <InlineTable noBorders>
            {
                Object.keys(grouped).map(date => {
                return (
                    <Fragment key={ date }>
                        { grouped[date].some(act => act.data) ?
                        <>
                            <TableRow className="group">
                                <TableCell colSpan={4}>
                                    <FormLabel>{ date }</FormLabel>
                                </TableCell>
                            </TableRow>
                            {
                            grouped[date].map(activity => {
                                return activity.data ? <ActivityRow activity={activity} uploads={uploads} currency={currency} /> : undefined
                            })}
                        </> : undefined}
                    </Fragment>)
                })
            }
            </InlineTable>
        </CollapsableSection>
    );

};

const ActivityRow = ({ activity, uploads = null, currency = null } : {
    activity : Activity,
    uploads? : Collection<Document>,
    currency? : string,
}) => {

    const attachment = uploads && uploads.find(file => Number(file.id) === activity.attachmentId);

    return (
        <CollapsibleTableRow
            key={ activity.cid }
            details={
                activity.data instanceof IncomingRemitanceAdviceActivity ? <IncomingRemitanceAdviceDetails data={activity.data} currency={currency} /> :
                activity.data instanceof RemittanceLinkedToInvoiceActivity ? <RemittanceLinkedToInvoiceDetails data={activity.data} currency={currency} /> :
                activity.data instanceof RemittanceLinkedToTransactionReconciledActivity ? <RemittanceLinkedToTransactionReconciledDetails data={activity.data} currency={currency} /> :
                activity.data instanceof IncomingTransactionActivity ? <IncomingTransactionDetails data={activity.data} currency={currency} /> :
                activity.data instanceof TransactionMovedToARActivity ? <TransactionMovedToARDetails data={activity.data} attachment={attachment} comment={activity.comment} currency={currency} /> :
                activity.data instanceof TransactionReconciledActivity ? <TransactionReconciledDetails data={activity.data} attachment={attachment} comment={activity.comment} currency={currency} /> :
                activity.data instanceof TransactionUnmatchedActivity ? <TransactionUnmatchedDetails data={activity.data} attachment={attachment} comment={activity.comment} currency={currency} /> :
                activity.data instanceof TransactionMovedUACActivity ? <TransactionMovedUACDetails data={activity.data} attachment={attachment} comment={activity.comment} currency={currency} /> :
                activity.data instanceof TransactionMovedToNonARActivity ? <TransactionMovedToNonARDetails data={activity.data} attachment={attachment} comment={activity.comment} currency={currency} /> :
                attachment ? <AttachmentDetails attachment={attachment} /> :
                undefined
            }
            tableRowClass="group">
                <TableCell className="fit-width">
                    <MessageIcon />
                </TableCell>
                <TableCell>
                    { activity.description || activity.type }
                </TableCell>

                <TableCell className="fit-width">
                    <FormValue>{ activity.userInfo
                        ? `${activity.userInfo.companyShortName ? activity.userInfo.companyShortName + ' - ' : '' }${activity.userInfo.firstName} ${activity.userInfo.lastName} ${activity.userInfo.email}`
                        : activity.createdBy }
                    </FormValue>
                </TableCell>
                <TableCell className="fit-width">
                    <FormLabel>{ asTime( activity.createdOn ) }</FormLabel>
                </TableCell>
        </CollapsibleTableRow>
    );
};

const AttachmentDetails = ({ attachment } : {
    attachment : Document
}) => {
   
    return (
        <CollapsableSection title="Comments">
            <p>{attachment && attachment.file_comments}</p>
            <FormLink label="Attachments" linkLabel={attachment && attachment.file_name} onClick={() => attachment && attachment.download()} />
        </CollapsableSection>
    );
}
